import {APIService, BillingGroupPlanSimpleSerializer, InsuranceCompanyPlanSerializer} from '../@core/api.service';
import {CONTRACT_NETWORK_STATUSES} from '../@core/contract_network_statuses';
import {PRIOR_AUTH_REQUIREMENTS} from '../@core/prior_auth_requirements';
import {HOSPICE_LOC_STATUSES} from '../@core/hospice_loc_statuses';
import {PRIOR_AUTH_HCPCS_EXCLUSIONS} from '../@core/prior_auth_hcpcs_exclusions';
import {NON_COVERED_HCPCS} from '../@core/non_covered_hcpcs';
import {ModelBase} from './model-base';

export class BillingGroupPlan extends ModelBase implements BillingGroupPlanSimpleSerializer {
    static viewSet = APIService.BillingGroupPlanViewSet;

    id: number;
    billing_group: number;
    created_by: number;
    created_at: Date | string;
    updated_at: Date | string;
    network: keyof typeof CONTRACT_NETWORK_STATUSES;
    prior_auth_requirements: (keyof typeof PRIOR_AUTH_REQUIREMENTS)[];
    hospice_loc: keyof typeof HOSPICE_LOC_STATUSES;
    prior_auth_hcpcs_exclusions: (keyof typeof PRIOR_AUTH_HCPCS_EXCLUSIONS)[];
    non_covered_hcpcs: (keyof typeof NON_COVERED_HCPCS)[];
    plan: InsuranceCompanyPlanSerializer;

    get networkText() {
        return this.network && CONTRACT_NETWORK_STATUSES[this.network];
    }

    get networkColorClass() {
        switch (this.network) {
            case 'IN_NETWORK':
                return 'success';
            case 'DIRECT_BILL':
            case 'IN_CONTRACT_REVIEW':
            case 'OON_MORE_THAN_50_BENEFITS':
            case 'OON_PRIOR_AUTH_REQUIRED':
            case 'TPA':
                return 'warning';
            case 'OON_INELIGIBLE':
                return 'danger';
        }
        return 'secondary';
    }

    get networkIcon() {
        if (!this.network) {
            return this.id ? 'check' : 'question';
        }
        switch (this.network) {
            case 'IN_NETWORK':
                return 'check';
            case 'DIRECT_BILL':
                return 'file-invoice-dollar';
            case 'IN_CONTRACT_REVIEW':
                return 'eye';
            case 'OON_MORE_THAN_50_BENEFITS':
            case 'OON_PRIOR_AUTH_REQUIRED':
            case 'TPA':
                return 'exclamation';
            case 'OON_INELIGIBLE':
                return 'times';
        }
    }

    get priorAuthRequirementsText() {
        return this.prior_auth_requirements?.map(x => PRIOR_AUTH_REQUIREMENTS[x] ?? x).join(', \n');
    }

    get hospiceLocText() {
        return this.hospice_loc && HOSPICE_LOC_STATUSES[this.hospice_loc];
    }
}
